import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { BannerMessageService } from 'src/app/services/banner-message.service';

@Component({
	selector: 'app-banner-message',
	imports: [],
	templateUrl: './banner-message.component.html',
	styleUrls: ['./banner-message.component.css'],
})
export class BannerMessageComponent implements OnInit, OnDestroy {
	subscription?: Subscription;

	constructor(
		private snackbar: MatSnackBar,
		private bannerMessageService: BannerMessageService
	) {}

	ngOnInit(): void {
		this.subscription = this.bannerMessageService
			.bannerMessages()
			.subscribe((message) => {
				this.snackbar.open(message.message, undefined, {
					duration: 3000,
					panelClass: message.automationId
						? [`banner-message-${message.automationId}`]
						: undefined,
				});
			});
	}

	ngOnDestroy(): void {
		this.subscription?.unsubscribe();
	}
}
